export default __webpack_public_path__ + "static/four-head-831c17e4ccb8e2273121678f36bfdf8b.jpg";